"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toStringMap = exports.toNumber = exports.toBoolean = void 0;
const toBoolean = (env) => {
    if (env === undefined) {
        return undefined;
    }
    if (env.toLowerCase() === 'true' || env === '1') {
        return true;
    }
    if (env.toLowerCase() === 'false' || env === '0') {
        return false;
    }
    return undefined;
};
exports.toBoolean = toBoolean;
const toNumber = (env) => {
    if (env === undefined || env.trim() === '') {
        return undefined;
    }
    const number = Number(env);
    if (isNaN(number)) {
        return undefined;
    }
    return number;
};
exports.toNumber = toNumber;
const toStringMap = (env) => {
    if (env === undefined) {
        return undefined;
    }
    const cleanedEnv = env.replace(/'/g, '"');
    try {
        const parsed = JSON.parse(cleanedEnv);
        // eslint-disable-next-line no-null/no-null
        if (typeof parsed === 'object' && parsed !== null) {
            for (const key in parsed) {
                if (typeof parsed[key] !== 'string') {
                    return undefined;
                }
            }
            return parsed;
        }
    }
    catch (error) {
        return undefined;
    }
};
exports.toStringMap = toStringMap;
//# sourceMappingURL=env.js.map